import React from 'react';

const StateSpecificReferences: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          State-Specific Legal References
        </h1>
        <div className="prose max-w-none">
          <p className="text-gray-600 mb-6">
            The following are the primary legal authorities used to inform the calculator’s rules for each state. These citations are provided for transparency and should not be interpreted as a complete statement of the law.
          </p>

          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b border-gray-200">
                    State
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b border-gray-200">
                    Primary Statutes
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border-b border-gray-200">
                    Key Principles
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200 font-medium">
                    New Mexico
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    N.M. Stat. §§ 40‑3‑8 to 40‑3‑14
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Community property; court makes a "just and equitable" division, not necessarily equal.
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200 font-medium">
                    Nevada
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Nev. Rev. Stat. § 125.150
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Community property; division must be "just and equitable."
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200 font-medium">
                    Arkansas
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Ark. Code §§ 9‑12‑315, 9‑12‑317
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Equitable distribution; court considers duration of marriage, income, and other factors.
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200 font-medium">
                    Florida
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Fla. Stat. § 61.075
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Equitable distribution with a starting presumption of 50/50; court may deviate based on enumerated factors.
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200 font-medium">
                    Texas
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Tex. Fam. Code §§ 7.001 – 7.008
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Community property; court divides property in a "just and right" manner, which may be unequal.
                  </td>
                </tr>
                <tr className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200 font-medium">
                    Georgia
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Ga. Code §§ 19‑5‑1, 19‑5‑13
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 border-b border-gray-200">
                    Equitable distribution; court considers length of marriage, contributions, and other equitable factors.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="text-sm text-gray-500 italic mt-6">
            <strong>Note:</strong> These citations are for reference only. Laws change, and judicial interpretations may vary. Always consult a qualified attorney for current legal advice.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StateSpecificReferences;
